import { createContext } from 'react';

export const AuthContext = createContext<{ signedIn: boolean }>({
  signedIn: false,
});

export default AuthContext;
